import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthFacade, DashboardFacade, customEncode } from '@piqet-angular/data';
import counterUp from 'counterup2';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-global-environmental-savings',
  templateUrl: './global-environmental-savings.component.html',
  styleUrls: ['./global-environmental-savings.component.scss'],
})
export class GlobalEnvironmentalSavingsComponent implements OnChanges, OnInit {
  showAchievements = true;
  totalProjectOfUser = 0;
  totalProjectOfOrganization = 0;
  userRegistredReDesign = 0;
  organizationRegistredReDesign = 0;
  userEnviromentalImpact = 0;
  enviromentalImpact = 0;
  totalProjectOfUserCount = 0;
  totalProjectOfOrganizationCount = 0;
  userRegistredReDesignCount = 0;
  organizationRegistredReDesignCount = 0;
  userEnviromentalImpactCount = 0;
  enviromentalImpactCount = 0;
  interval: any;
  getglobalsavingsData: any;
  @Input() environmentData: any;
  @Input() stepCount: any;
  @Input() stepTitle: any;
  @Input() stepText: any;

  @Output() achivementsEvent = new EventEmitter<any>();
  @ViewChild('counter') counter: ElementRef | undefined;

  callback = (entries: any) => {
    entries.forEach((entry: any) => {
      const el = entry.target;
      if (entry.target.classList[2] == 'counter-1') {
        el.innerText = this.totalProjectOfUser;
      }
      if (entry.target.classList[2] == 'counter-2') {
        el.innerText = this.totalProjectOfOrganization;
      }
      if (entry.target.classList[2] == 'counter-3') {
        el.innerText = this.userRegistredReDesign;
      }
      if (entry.target.classList[2] == 'counter-4') {
        el.innerText = this.organizationRegistredReDesign;
      }
      if (entry.target.classList[2] == 'counter-5') {
        el.innerText = this.userEnviromentalImpact;
      }
      if (entry.target.classList[2] == 'counter-6') {
        el.innerText = this.enviromentalImpact;
      }

      let previousY = 0;
      let previousRatio = 0;
      if (entry.isIntersecting && !el.classList.contains('is-visible')) {
        counterUp(el, {
          duration: 1000,
        });
      }
      const currentY = entry.boundingClientRect.y;
      const currentRatio = entry.intersectionRatio;
      const isIntersecting = entry.isIntersecting;

      if (currentY < previousY) {
        el.classList.add('is-visible');
      } else if (currentY > previousY && isIntersecting) {
        el.classList.remove('is-visible');
      }

      previousY = currentY;
      previousRatio = currentRatio;
    });
  };

  constructor(
    public DashboardFacade: DashboardFacade,
    private router: Router,
    public authFacade: AuthFacade,
    private cookieService: CookieService,
    public sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.GetDashboardglobalSavings();
  }

  GetDashboardglobalSavings() {
    this.DashboardFacade.getDashboardData$.subscribe(data => {
      this.getglobalsavingsData = data;
      this.totalProjectOfUser = this.getglobalsavingsData?.totalProjectOfUser;
      this.totalProjectOfOrganization = this.getglobalsavingsData?.totalProjectOfOrganization;
      this.userRegistredReDesign = this.getglobalsavingsData?.userRegistredReDesign;
      this.organizationRegistredReDesign = this.getglobalsavingsData?.organizationRegistredReDesign;
      this.userEnviromentalImpact = this.getglobalsavingsData?.userEnviromentalImpact;
      this.enviromentalImpact = this.getglobalsavingsData?.enviromentalImpact;
    });
  }

  onNext() {
    const getPackageId: any = this.cookieService.get('gT_PackageId');
    const encodedValue = encodeURIComponent(parseFloat(getPackageId || 0)); // Sample PROJECT ID
    this.router.navigate([
      'projects/projects-setting',
      customEncode(btoa(encodedValue)),
      'setting',
    ]);
  }

  counterAnimation() {
    setTimeout(() => {
      const el1: any = document.querySelector('.counter-1');
      const el2: any = document.querySelector('.counter-2');
      const el3: any = document.querySelector('.counter-3');
      const el4: any = document.querySelector('.counter-4');
      const el5: any = document.querySelector('.counter-5');
      const el6: any = document.querySelector('.counter-6');
      const IO = new IntersectionObserver(this.callback, { threshold: 1 });
      if (el1 && el2 && el3 && el4 && el5 && el6) {
        IO?.observe(el1);
        IO?.observe(el2);
        IO?.observe(el3);
        IO?.observe(el4);
        IO?.observe(el5);
        IO?.observe(el6);
      }
    }, 100);
  }

  ngOnChanges() {
    this.showAchievements = this.environmentData?.isShowPersonalAchievement;
    this.counterAnimation();
  }

  toggleAchievements(showAchievements: boolean) {
    this.counterAnimation();
    this.achivementsEvent.emit(showAchievements);
  }
}
